var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.type === "edit" ? "编辑" : "新增",
        visible: _vm.dialog,
        width: _vm.getIsMobile ? "100%" : "50%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.handleClose,
        "append-to-body": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialog = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          attrs: {
            model: _vm.form,
            "label-width": "80px",
            "label-position": _vm.getIsMobile ? "top" : "right",
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "型号", prop: "ArticleTitle" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入型号" },
                model: {
                  value: _vm.form.ArticleTitle,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "ArticleTitle", $$v)
                  },
                  expression: "form.ArticleTitle",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "品牌", prop: "ArticleSource" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入品牌" },
                model: {
                  value: _vm.form.ArticleSource,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "ArticleSource", $$v)
                  },
                  expression: "form.ArticleSource",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "价格", prop: "renshu" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入价格" },
                model: {
                  value: _vm.form.renshu,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "renshu", $$v)
                  },
                  expression: "form.renshu",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "价格来源", prop: "address" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入价格来源" },
                model: {
                  value: _vm.form.address,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "address", $$v)
                  },
                  expression: "form.address",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "是否含税", prop: "shui" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.shui,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "shui", $$v)
                    },
                    expression: "form.shui",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("含税")]),
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("未税")]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { "margin-right": "5px" },
              on: { click: _vm.handleReset },
            },
            [_vm._v("重 置")]
          ),
          _c(
            "el-popconfirm",
            {
              attrs: { title: "确定要添加这个型号吗？" },
              on: { confirm: _vm.handleSubmit },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { slot: "reference", type: "primary" },
                  slot: "reference",
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }